import { GlFilteredSearchSuggestion } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import { __ } from '~/locale';
import BaseToken from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/filtered_search_bar/tokens/base_token.vue?vue3';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
import { OPTIONS_NONE_ANY } from '../constants';
export default {
    name: 'ReleaseToken',
    components: {
        BaseToken,
        GlFilteredSearchSuggestion
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        active: {
            type: Boolean,
            required: true
        },
        config: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            releases: this.config.initialReleases || [],
            loading: false
        };
    },
    computed: {
        defaultReleases () {
            return this.config.defaultReleases || OPTIONS_NONE_ANY;
        }
    },
    methods: {
        getActiveRelease (releases, data) {
            return releases.find((release)=>release.tag.toLowerCase() === data.toLowerCase());
        },
        fetchReleases (searchTerm) {
            this.loading = true;
            this.config.fetchReleases(searchTerm).then((response)=>{
                this.releases = response;
            }).catch(()=>{
                createAlert({
                    message: __('There was a problem fetching releases.')
                });
            }).finally(()=>{
                this.loading = false;
            });
        }
    }
};
